import { render } from "./SaasIcon.vue?vue&type=template&id=77bdf51e"
import script from "./SaasIcon.vue?vue&type=script&lang=js"
export * from "./SaasIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__